import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '../pages/LandingPage/LandingPage';
import Login from '../pages/Login/Login';
import SignUp from '../pages/SignUp/SignUp';
import InstitutionSignUp from '../pages/InstitutionSignUp/InstitutionSignUp';
import OnboardingChoice from '../pages/OnboardingChoice/OnboardingChoice';
import Onboarding from '../pages/Onboarding/Onboarding';
import Dashboard from '../pages/Dashboard/Dashboard';
import { Chat } from '../pages/Chat/Chat';
import { MindMap } from '../pages/MindMap/MindMap';
import { ProtectedRoute } from './ProtectedRoute';
import BrandKit from '../pages/BrandKit/BrandKit';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/LandPage" replace />} />
      <Route path="/LandPage" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/cadastro-professor" element={<SignUp mode="teacher" />} />
      <Route path="/cadastro-instituicao" element={<InstitutionSignUp />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/onboarding-choice" element={<OnboardingChoice />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/mindmap" element={<MindMap />} />
      </Route>

      <Route path="/brand" element={<BrandKit />} />
      <Route path="*" element={<Navigate to="/LandPage" replace />} />
    </Routes>
  );
}